export const NOTIFICATION = "NOTIFICATION";
export const SET_PERMITION = "SET_PERMITION";

export const notificationAlert = (payload) => (dispatch) =>
  dispatch({
    type: NOTIFICATION,
    payload: payload,
  });
